/*
 * @author: wayou
 * @date: 2018-12-13 13:15:56
 * @description: ai 报告中关键词数据
 */

import { fetch } from '@umu/umu-fetch';
import { IHomeworkInfo, KEYWORD_TASK_STATUS, HomeworkType } from '@umu/umu-types';
import { IAiReportData } from '@umu/umu-types/src/interface/aiReportInfo';
export { HomeworkType as homeworkTypeMap } from '@umu/umu-types';

export interface IGetHomeworkKeywordsRequest {
    homework_id: number | string;
    student_id: string;
    return_text: number;
}

export interface IGetKeywordsResponse {
    keywords_task_status: KEYWORD_TASK_STATUS;
    keywords: {
        word_num: number;
        keyword_coverage: number;
        list: IKeywordItem[];
    };
    shield_keywords: {
        word_num: number;
        keyword_coverage: number;
        list: IKeywordItem[];
    };
    frequency_words: {
        word_num: number;
        list: IKeywordItem[];
    };
    show_keyword_coverage: number; // 0 不展示 1 展示
    text: string;
    ai_report_info?: IAiReportData;
    user_info: IUserInfo;
    homework_info: IHomeworkInfo;
    homework_type: HomeworkType;
    highlight:string[]; // 关键词高亮
    mantra_highlights: string[]; // 口头禅高亮
    shield_highlight_keywords: string[]; //屏蔽关键词高亮

}

export const getHomeworkKeywords = (params: IGetHomeworkKeywordsRequest): Promise<IResponse<IGetKeywordsResponse>> => {
    return fetch.get('/uapi/v1/homework/ai-report', params);
};
